// 职位管理相关API接口
import request from '@/utils/request'

/**
 * 获取职位 带分页
 * @param data
 * @returns {*}
 */
export function getPositionPage(params,data) {
    return request({
        url: '/position/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 获取用户下级职务列表
 * @param data
 * @returns {*}
 */
export function getPositionList(params) {
    return request({
        url: '/position/list',
        method: 'get',
        params
    })
}
/**
 * 删除职务
 * @param data 整个对象
 * @returns {*}
 */
export function delPosition(data) {
    return request({
        url: '/position',
        method: 'delete',
        data
    })
}
/**
 * 添加职务
 * @param data
 * @returns {*}
 */
export function addPosition(data) {
    return request({
        url: '/position',
        method: 'post',
        data
    })
}
/**
 * 更新职务
 * @param data
 * @returns {*}
 */
export function updatePosition(data) {
    return request({
        url: '/position',
        method: 'put',
        data
    })
}

/**
 * 检查职务是否存在
 * @param data 有code就行
 * @returns {*}
 */
export function existPosition(data) {
    return request({
        url: '/position/exist',
        method: 'post',
        data
    })
}
